import { Grid, Link } from "@mui/material"

import { MakeOSIcon } from "@/common/CommonComponents"
import { useIsHidden } from "@/nav/navHooks"


export default function Footer({ showLogo }) {
    const isNavHidden = useIsHidden()

    const style = {
        paddingTop: 30,
        paddingBottom: 50,
        width: "100%",
        textAlign: "center",
        boxSizing: "border-box",
        position: "absolute",
        bottom: 0,
    }
    
    return (
        <div style={style}>
            {!isNavHidden && (
                <Grid container alignItems={"center"} justifyContent={"center"} marginBottom={1}>
                    <Grid item>
                        <MakeOSIcon width={120} />
                    </Grid>
                </Grid>
            )}
            <Grid container spacing={1} alignItems={"center"} alignContent={"center"} justifyContent={"center"}>
                <Grid item>
                    <Link sx={{fontSize: 12}} target="_blank" href="/terms-of-use">
                        Terms of Use
                    </Link>
                </Grid>
                <Grid item sx={{fontSize: 12}}>
                    &
                </Grid>
                <Grid item>
                    <Link sx={{fontSize: 12}} target="_blank" href="/privacy-policy">
                        Privacy Policy
                    </Link>
                </Grid>
            </Grid>
        </div>
    )
}
